<template>
  <div class="company-survey">
    <div class='preference-questionnaire'>
      <div class="title">{{ $t(`${i18nPrefix}.title.preferenceQuestion`) }}</div>
      <div class="question-list">
        <div v-for="(question, index) in questionList" class="question-container" :key="index">
          <div class="question-title">
            <span class="question-label">{{ $t(`${i18nPrefix}.label.question`) }} </span>
            <span class="question-content">{{ question.i18nName }}</span>
          </div>
          <div class="question-answer">
            <span class="answer-label">{{ $t(`${i18nPrefix}.label.answer`) }}: </span>
            <span class="answer-content">{{question.answer}}</span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="notification" class="notification">
      <div class="title">{{ $t(`${i18nPrefix}.title.notification`) }}</div>
      <div class="notification-container">
        <div class="frequency notification-info">
          <span class="label">{{ $t(`${i18nPrefix}.label.notificationFrequency`) }}: </span>
          <span class="content">{{ frequencyMap[notification.frequency] }}</span>
        </div>
        <div class="channel notification-info">
          <span class="label">{{ $t(`${i18nPrefix}.label.notificationChannel`) }}: </span>
          <span class="content">{{ notificationTypeMap[notification.notification_type] }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    questionList: {
      type: Array,
      required: true
    },
    notification: {
      type: Object
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.application.candidate'
    }
  },
  computed: {
    frequencyMap () {
      return {
        never: this.$t(`${this.i18nPrefix}.label.notification.never`),
        weekly: this.$t(`${this.i18nPrefix}.label.notification.weekly`),
        monthly: this.$t(`${this.i18nPrefix}.label.notification.monthly`)
      }
    },
    notificationTypeMap () {
      return {
        email: this.$t(`${this.i18nPrefix}.label.notification.email`),
        wechat: this.$t(`${this.i18nPrefix}.label.notification.wechat`),
        both: this.$t(`${this.i18nPrefix}.label.notification.both`)
      }
    }
  },
  created () {

  },
  methods: {

  }
}
</script>
<style lang='scss' scoped>
.company-survey {
  margin-top: 60px;
  padding: 0 20px;
  color: #606266;

  .preference-questionnaire {
    .title {
      font-size: 18px;
      color: #303133;
      font-weight: bold;
    }

    .question-list {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      .question-container {
        margin-top: 30px;
        width: 48%;
        padding: 20px 40px;
        border: 1px solid #dcdfe6;
        background-color: #fbfbfb;

        .question-answer {
          margin-top: 20px;
          line-height: 22px;
        }

        .question-title {
          line-height: 22px;
        }
      }
    }
  }

  .notification {
    margin-top: 40px;

    .title {
      font-size: 18px;
      color: #303133;
      font-weight: bold;
    }

    .notification-container {
      display: flex;
      margin-top: 30px;

      .notification-info {
        border: 1px solid #dfdfdf;
        padding: 8px 58px;
        margin-right: 30px;
      }
    }
  }
}
</style>
